
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import preferencesService from "@/services/preferences.service";
import {namespace} from "vuex-class";

const userModule = namespace("userModule");

@Component({
    components: {}
})
export default class FieldIdentifier extends Vue {

    @Prop() readonly items;
    @Prop() readonly obligatory;
    @Prop() readonly fileId;
    @Prop() readonly identifiers;
    @Prop() readonly title;
    @Prop() readonly subtitle;

    @userModule.State
    public user: any;

    headersFromFile = [];
    idFieldsFile = ["siren", "siret"];
    idFieldFileInput = null;
    idFieldTypeFileInput = "siren";

    @Watch('items', {deep: true, immediate: true})
    refresh(items) {
        this.headersFromFile = [];

        if (items && items.length > 0) {
            const length = Object.keys(items[0]).length - 2;
            for (let index = 0; index < length; index++) {
                this.headersFromFile.push({
                    text: index + "",
                    value: index + "",
                    align: 'left'
                });
            }
        }
        this.idFieldFileInput = null;
        this.idFieldTypeFileInput = "siren";
        if (this.identifiers) {
            this.idFieldTypeFileInput = this.identifiers.type;
            this.idFieldFileInput = this.identifiers.column;
        }
    }


    savePreferenceIdFile(value) {
        const identifier = {
            type: this.idFieldTypeFileInput,
            column: value
        };
        preferencesService.updateFileRepellerIdentifier(
            this.fileId,
            identifier,
            this.user.id
        );
    }

    capitalizeFirstLetter(value) {
      return value ? value[0].toUpperCase() + value.slice(1) : "";
    }
}
